export class AuthConfig {
   public allowed_cors_orgins;
   public application_type: string;
   public jwt_expiration: Number;
   public logo: string;
   public  logout_url: string;
   public return_url: string;
   public active: boolean;
   public main_redirect_url: string;
   public urlInvalid: UrlConfig;
   public updated_by: string;
   public  application_name: string;
   /**
    *
    */
   constructor() {
     this.urlInvalid = new UrlConfig();

   }
}

export class UrlConfig {
  public active: boolean;
  public main_redirect_url: string;
  constructor() {
  }
}
